export default "__VITE_ASSET__e4b62fbd__"